module.exports = __webpack_public_path__ + "static/img/ism-logo.08b02fd0.png";